import React, {useEffect} from 'react';

export default function ValidatorCallbackSdk() {

    function getParams() {
        var url = window.location.href;

        var parametros = url.split('?')[1];

        if (parametros) {
            var parametrosArray = parametros.split('&');

            var parametrosObjeto = {};

            parametrosArray.forEach(function(parametro) {
                var par = parametro.split('=');
                parametrosObjeto[par[0]] = par[1];
            });
            return parametrosObjeto
        }
    }
    function emitToIOS(params) {
        try {
            const decodedQuery = decodeURIComponent(window.location.href.split("Response=")[1]);
            const jsonData = JSON.parse(decodedQuery);
            console.log('jsonData', jsonData);
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify(jsonData));
        } catch (e) {
            window.webkit.messageHandlers.messageHandlersName.postMessage('Error de parametros');
        }
    }
    useEffect(() => {
        const params = getParams();
        console.log('params', params);
        if (params) {
            emitToIOS(params);
        }
    }, []);
    return (
        <div>

        </div>
    )
}
